
import React from 'react';
import './semantic_compiled/light/semantic.min.css';

const Theme = ({children}) => (<React.Fragment>{children}</React.Fragment>);

export default Theme;